import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "carouselBox" }

import ThinFrame from "@/components/Common/ThinFrame.vue";

import { defineComponent } from 'vue'

const __default__ = defineComponent({
    name: 'ScreenshotCarousel',

    data() {
        return {
        }
    },
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ThinFrame, { offset: 7 }),
    _cache[0] || (_cache[0] = _createStaticVNode("<div id=\"carouselExampleAutoplaying\" class=\"carousel slide\" data-bs-ride=\"carousel\" data-bs-interval=\"4000\" data-v-0f967f82><div class=\"carousel-inner\" data-v-0f967f82><div class=\"carousel-item active\" data-v-0f967f82><img src=\"/img/page/landing/screenshot/1.jpg\" class=\"d-block w-100\" alt=\"...\" data-v-0f967f82></div><div class=\"carousel-item\" data-v-0f967f82><img src=\"/img/page/landing/screenshot/3.jpg\" class=\"d-block w-100\" alt=\"...\" data-v-0f967f82></div><div class=\"carousel-item\" data-v-0f967f82><img src=\"/img/page/landing/screenshot/4.jpg\" class=\"d-block w-100\" alt=\"...\" data-v-0f967f82></div><div class=\"carousel-item\" data-v-0f967f82><img src=\"/img/page/landing/screenshot/2.jpg\" class=\"d-block w-100\" alt=\"...\" data-v-0f967f82></div><div class=\"carousel-item\" data-v-0f967f82><img src=\"/img/page/landing/screenshot/5.jpg\" class=\"d-block w-100\" alt=\"...\" data-v-0f967f82></div><div class=\"carousel-item\" data-v-0f967f82><img src=\"/img/page/landing/screenshot/6.jpg\" class=\"d-block w-100\" alt=\"...\" data-v-0f967f82></div></div><button class=\"carousel-control-prev\" type=\"button\" data-bs-target=\"#carouselExampleAutoplaying\" data-bs-slide=\"prev\" data-v-0f967f82><span class=\"carousel-control-prev-icon\" aria-hidden=\"true\" data-v-0f967f82></span><span class=\"visually-hidden\" data-v-0f967f82>Previous</span></button><button class=\"carousel-control-next\" type=\"button\" data-bs-target=\"#carouselExampleAutoplaying\" data-bs-slide=\"next\" data-v-0f967f82><span class=\"carousel-control-next-icon\" aria-hidden=\"true\" data-v-0f967f82></span><span class=\"visually-hidden\" data-v-0f967f82>Next</span></button></div>", 1))
  ]))
}
}

})